var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 144,
    viewBox: "0 0 203 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 78,
    r: 66,
    fill: "#FDF7F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 56,
    r: 22,
    fill: "#FDF7F9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FDF7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6673 60.6666H83.334C85.7173 60.6666 87.6673 62.6166 87.6673 65V91C87.6673 93.3833 85.7173 95.3333 83.334 95.3333H48.6673C46.284 95.3333 44.334 93.3833 44.334 91V65C44.334 62.6166 46.284 60.6666 48.6673 60.6666Z",
    stroke: "#F75D21",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6673 65L66.0006 80.1667L44.334 65",
    stroke: "#F75D21",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1aa9babe86d4a157b007c1a2d63da31d.svg";
export { ForwardRef as ReactComponent };